var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-empty"},[_c('v-icon',{attrs:{"large":""}},[_vm._v(_vm._s(_vm.icon))]),_c('div',[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }